import { Component, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { McqService } from '../../service/mcq.service';
import { commonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';

import { ViewEncapsulation } from '@angular/core'


@Component({
  selector: 'app-overallreport',
  templateUrl: './overallreport.component.html',
  styleUrls: ['./overallreport.component.css', '../../../../src/webassets/css/style.scss',],
  encapsulation: ViewEncapsulation.None,
  providers: [McqService]
})


export class OverallreportComponent implements AfterViewInit {
  @Input() public adminDetail;
  reportId: any;
  userData: any;
  msg = '';
  isError = false;
  reportData: any;
  studendRank: any;
  totalStudentCount: any;
  sectionData: any = [];
  sectionName: any = [];
  topTen: any = [];
  isSR: boolean = false;
  solutionObj = {};
  isPostLoad = true;

  // bar chart for section wise report
  public sectionBarChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    borderSkipped: true,
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index]; },
        label: function (tooltipItems, data) {
          return ' ' + tooltipItems.xLabel + ' Marks';
        }
      }
    },
    scales: {
      xAxes: [{
        gridLines: {
          //color: "rgba(0, 0, 0, 0)",
        },
      }],
      yAxes: [{
        gridLines: {
          color: "rgba(0, 0, 0, 0)", //use for disable
        },
        ticks: {
          // display: false //this will remove only the label
        },
        barThickness: 30
      }]
    }
  };

  public sectionBarChartType: string = 'horizontalBar';
  public sectionBarChartLegend: boolean = false;

  public sectionBarChartData: any[] = [{ data: [] }];
  public sectionBarChartColors: Array<any> = [
    {
      borderColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)", "rgb(255, 205, 86)", "rgb(255, 159, 64)", "rgb(54, 162, 235)", "rgb(153, 102, 255)", "rgb(201, 203, 207)"],
      borderWidth: 2,
      backgroundColor: ["rgba(255, 99, 132, 0.6)", "rgba(75, 192, 192, 0.6)", "rgba(255, 205, 86, 0.5)", "rgba(255, 159, 64, 0.5)", "rgba(54, 162, 235, 0.5)", "rgba(153, 102, 255, 0.2)", "rgba(201, 203, 207, 0.2)"],
    }

  ];
  // END OF BAR CHART


  // Dificulty level Doughnut 
  public doughnutDifficultyLabels: string[] = [
    'Easy',
    'Medium',
    'Difficult'
  ];
  public doughnutDifficultyData: any[] = [];
  public doughnutDifficultyType: string = 'doughnut';

  public doughnutDifficultyOptions: any = {
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          return data['labels'][tooltipItem[0]['index']];
        },
        label: function (tooltipItem, data) {
          return data['datasets'][0]['data'][tooltipItem['index']] + '%';
        }
      },
      backgroundColor: '#FFF',
      titleFontSize: 14,
      titleFontColor: '#0066ff',
      bodyFontColor: '#000',
      bodyFontSize: 14,
      displayColors: false
    }
  }
  //END OF Dificulty level DOUGHNUT  


  // TIME WISE Doughnut 
  public doughnutChartLabels: string[] = [
    'Right',
    'Wrong',
    'Skipped'
  ];
  public doughnutChartData: any[] = [];
  public doughnutChartType: string = 'doughnut';

  public doughnutChartOptions: any = {
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          return data['labels'][tooltipItem[0]['index']];
        },
        label: function (tooltipItem, data) {
          return data['datasets'][0]['data'][tooltipItem['index']] + '%';
        }
      },
      backgroundColor: '#FFF',
      titleFontSize: 14,
      titleFontColor: '#0066ff',
      bodyFontColor: '#000',
      bodyFontSize: 14,
      displayColors: false
    }
  }
  //END OF DOUGHNUT 

  constructor(private route: ActivatedRoute, private router: Router, private mcqservice: McqService, private commonService: commonService) {

    this.userData = this.commonService.user;

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.reportId = parseInt(atob(params['id']));
        if (isNaN(this.reportId)) {
          this.reportId = 0;
          this.router.navigateByUrl('/');
        }

        if (this.reportId > 0) {
          this.getStudentReportIdWise();
        }
      }
    });

  }

  ngAfterViewInit() {

  }

  ngOnInit() {
    //view report detail in admin section.
    if (this.adminDetail) {
      this.userData.id = this.adminDetail.userId;
      this.reportId = this.adminDetail.reportId;
      this.getStudentReportIdWise();
    }
  }

  getStudentReportIdWise() {
    let obj = {};
    obj['studentId'] = this.userData.id;
    obj['paperId'] = this.reportId;

    this.mcqservice.getStudentReportIdWise(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.reportData.length > 0) {
          this.reportData = data.results.reportData[0];
          //console.log('report data', this.reportData);
          this.studendRank = data.results.studendRank[0];
          this.totalStudentCount = data.results.totalStudentCount[0];
          this.getSectionWiseReport();
        } else {
          this.reportData = {};
          this.studendRank = {};
          this.totalStudentCount = {};
        }
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.msg = "internal server error!";
    });
  }

  // get section wise paper data
  getSectionWiseReport() {
    let obj = {};
    obj['studentId'] = this.userData.id;
    obj['paperId'] = this.reportId;

    this.mcqservice.getSectionWiseReport(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.length > 0) {
          this.sectionData.push('0'); //set start from zero
          this.sectionName.push(''); //section level start from null
          for (let s of data.results) {
            let TotalRightMarks = s.totalRightMarks;
            let TotalWrongMarks = s.totalWrongMarks;
            let FinalMarks = Number(TotalRightMarks) + Number(TotalWrongMarks);
            this.sectionName.push(s.sectionName);
            this.sectionData.push(Number(FinalMarks).toFixed(2));
          }
          // set data to bar chart
          this.sectionBarChartData = [{ data: this.sectionData }];
          // set data to daughnut chart calcute in persentage
          let pt = Math.round((parseInt(this.reportData.totalRightAnsTime) * 100) / (this.reportData.totalTime * 60)).toFixed(2);
          let ut = Math.round(((this.reportData.totalTime * 60) - this.reportData.totalRightAnsTime - this.reportData.totalLeftAnsTime - this.reportData.totalWrongAnsTime) * 100 / (this.reportData.totalTime * 60)).toFixed(2);
          let st = Math.round((this.reportData.totalLeftAnsTime * 100) / (this.reportData.totalTime * 60)).toFixed(2);
          //console.log('TIME WISE',pt,ut,st);
          this.doughnutChartData = [pt, ut, st];
          this.getTopTenStudentsReport();
          this.getDifficutyLevelReport();
          //console.log("section name no Data found",this.sectionData,this.sectionName);
        } else {
          console.log("section name no Data found");
        }

      } else {
        console.log("section name error in query");
      }
    }, (error: HttpErrorResponse) => {
      console.log("section name internal server error!");
    });
  }

  // get Diiiculty level wise paper data
  getDifficutyLevelReport() {
    let obj = {};
    obj['paperId'] = this.reportId;

    this.mcqservice.getDifficutyLevelReport(obj).subscribe((data: any) => {
      var e, m, d: any = 0;
      if (data.error == 0) {
        if (data.results.length > 0) {
          for (let s of data.results) {
            // set data to daughnut chart calcute in persentage
            /// if(s.Qtype=='1'){ //easy
            e = Math.round((parseInt(s.totalRightCount) * 100) / (s.totalQuestions)).toFixed(2);
            /// }else if (s.Qtype=='2'){ //medium
            m = Math.round((parseInt(s.totalWrongCount) * 100) / (s.totalQuestions)).toFixed(2);
            // }else if(s.Qtype=='3'){ // hard
            d = Math.round((parseInt(s.totalLeftCount) * 100) / (s.totalQuestions)).toFixed(2);
            // }
          }

          //console.log('Difficult WISE',e,m,d);
          this.doughnutDifficultyData = [e, m, d];
        } else {
          this.doughnutDifficultyData = [];
          console.log("Difficuty Level: no Data found");
        }

      } else {
        console.log("Difficuty Level: error in query");
      }
    }, (error: HttpErrorResponse) => {
      console.log("Difficuty Level: internal server error!");
    });
  }

  getTimeFormat(seconds) {
    return this.mcqservice.getFormatTime(seconds);
  }
  ConvertString(str) {
    str = (str!='' && str!=null) ? str : 0;
    str = (!isNaN(parseFloat(str)))  ? str : 0;
    return parseInt(str);
  }

  roundoff(n) {
    n = (n!='' && n!=null) ? n : 0;
    n = (!isNaN(parseFloat(n))) ? parseFloat(n) : 0;
    return Number(n).toFixed(2);
  }

  getRankPercentage(rank, total) {
    if (parseInt(rank) > 1) {
      let x = 1 / parseInt(total) * 100;
      return 100 - (parseInt(rank) * x);
    } else {
      return 100;
    }
  }


  testpositionretun(cond) {
    if (cond == 1) {
      return 'st';
    } else if (cond == 2) {
      return 'nd';
    } else if (cond == 3) {
      return 'rd';
    } else {
      return 'th';
    }

  }

  getTopTenStudentsReport() {
    let obj = {};
    obj['paperId'] = this.reportId;

    this.mcqservice.getTopTenStudentsReport(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.length > 0) {
          this.topTen = data.results;
          this.solutionObj = { 'reportId': this.reportId, 'toperId': this.topTen[0].studentId };
          let topTenArr = []
          let i = 0
          for (let s of data.results) {
            i++;
            let position = (s.studentId == this.userData.id) ? i + this.testpositionretun(i) + ' (You)' : i + this.testpositionretun(i);
            this.barChartLabels.push(position);
            //console.log('Data',s);
            let x = this.roundoff(Number(s.totalRightMarks) + Number(s.totalWrongMarks))
            topTenArr.push(x);
          }
          // set data to bar chart
          this.barChartData = [{ data: topTenArr }];
          //console.log('barChartData',this.barChartData);
        } else {
          this.topTen = [];
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
      this.isPostLoad = false;
    }, (error: HttpErrorResponse) => {
      this.msg = "internal server error!";
    });
  }

  onClickSolutionReport() {
    this.isSR = true;
  }

  //This is line chart
  // bar chart
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    barThickness: 10,
    borderSkipped: true,
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) { return 'Topper ' + data.labels[tooltipItem[0].index]; },
        label: function (tooltipItems, data) {
          return 'Score ' + tooltipItems.yLabel;
        }
      }
    },
    scales: {
      xAxes: [{
        gridLines: {
          color: "rgba(0, 0, 0, 0)",
        },
        barThickness: 30,
      }],
      yAxes: [{
        gridLines: {
          //color: "rgba(0, 0, 0, 0)",
        },
        ticks: {
          display: false //this will remove only the label
        }
      }]
    }
  };

  public barChartLabels: string[] = [];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;

  public barChartData: any[] = [
    { data: [] },
    //{ data: [65, 59, 80, 81, 56, 55, 40, 30, 50, 10, 5], label: 'Iphone X' }
  ];
  public barChartColors: Array<any> = [
    { backgroundColor: ['#55ce63', '#009efb', '#009efb', '#009efb', '#009efb', '#009efb', '#55ce63', '#009efb', '#55ce63', '#55ce63', '#55ce63'], },
    { backgroundColor: '#009efb' }
  ];

  /*********end of bar chart ************ */


  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }


  showtimeformatAcc(time) {
    if(this.reportData && this.reportData.totalTime>0){
    let maxtime = this.reportData.totalTime*60;
    time = (time>maxtime) ? maxtime : time;
    }
    let timenewformat = this.getTimeFormat(time);
    let timearr: any;
    timearr = timenewformat.split(":")
    //timearr = ['1', '2', '12']
    //console.log('time new format', timenewformat.split(":"));
    
    return ((timearr[0] > 0) ? (timearr[0] + ' hrs, ') : ('')) + ((timearr[1] > 0) ? (timearr[1] + ' min, ') : ('')) + ((timearr[2] > 0) ? (timearr[2] + ' sec') : (''));
    }




}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/overallreport/overallreport.component.ts